module.exports = __webpack_public_path__ + "static/assets/img/remote_work_1.06c1ea43.svg";